import { getDataUrl } from '../utils/apiConfig';
import './CompareWorkshops.css';

function getValue(object, path) {
    let keys = path.split('.');
    let result = object;

    for(let key of keys) {
        result = result[key];
    }
    // avoid adding decimals to whole numbers, e.g. ids
    if (typeof result === 'number') {
        if (result % 1 !== 0) {
            result = result.toFixed(1)
        }
    }

    return result;
}

const CompareWorkshopsRow = ({ title, comparedWorkshops, workshopDetails, property }) => {
        
    const base = getDataUrl() + "/";    

    return (
        <div className="columns">
            <div className='column is-2 mt-3 mb-3'>
                <div className='title is-5'>
                    {title}
                </div>
            </div>
            {comparedWorkshops.map((workshop, index) => (                    
                <div key={workshop.id} className='column has-background-white m-3'>
                    {getValue(workshopDetails[index], property)}                    
                </div>
            ))}            
        </div>
    );
};

export default CompareWorkshopsRow;
